// Single source of truth for clinic data — easy to update later
export const CLINIC = {
  doctorName: "Dr. Luis Rodrigo González Azuara",
  shortName: "Dr. Luis Rodrigo González Azuara",
  specialty: "Cardiología · Cuidados Coronarios · Ecocardiografía · Especialista en terapia ECMO",
  specialtyShort: "Cardiología Avanzada",
  brand: "Cardiología Avanzada",
  logoUrl: "https://customer-assets.emergentagent.com/job_expert-heart-care/artifacts/kiiuv0ea_logo.png",
  yearsExperience: 15,
  whatsappNumber: "524491396776",
  whatsappDisplay: "+52 449 139 6776",
  phoneNumber: "+524495407099",
  phoneDisplay: "(449) 540 7099",
  emergencyNumber: "+525554532597",
  emergencyDisplay: "(555) 453 2597",
  email: "dr.rodgoaz@gmail.com",

  // Multiple consultorios
  consultorios: [
    {
      id: "mac-norte",
      label: "Consultorio 1",
      name: "Hospital MAC Norte",
      addressLine1: "Hospital MAC Norte, Consultorio 527",
      addressLine2: "Blvd. Luis Donaldo Colosio Murrieta 106",
      city: "Aguascalientes, Ags.",
      mapsQuery: "Hospital MAC Norte, Blvd. Luis Donaldo Colosio Murrieta 106, Aguascalientes",
      mapsLink: "https://www.google.com/maps/search/?api=1&query=Hospital+MAC+Norte+Aguascalientes",
      schedule: [
        { label: "Mañanas", time: "12:00 – 15:00 hrs", days: "Lun · Mié · Vie" },
        { label: "Tardes",  time: "16:30 – 20:00 hrs", days: "Lun – Vie" },
      ],
    },
    {
      id: "galerias",
      label: "Consultorio 2",
      name: "Centro Médico Galerías",
      addressLine1: "Centro Médico Galerías",
      addressLine2: "Av. Independencia, Trojes de Alonso",
      city: "Aguascalientes, Ags.",
      mapsQuery: "Centro Médico Galerías, Av Independencia, Trojes de Alonso, Aguascalientes",
      mapsLink: "https://www.google.com/maps/search/?api=1&query=Centro+M%C3%A9dico+Galer%C3%ADas+Trojes+de+Alonso+Aguascalientes",
      schedule: [
        { label: "Tardes", time: "16:30 – 20:00 hrs", days: "Mar · Jue" },
      ],
    },
  ],

  // Backward compat — used by Footer
  address: {
    line1: "Hospital MAC Norte, Consultorio 527",
    line2: "Blvd. Luis Donaldo Colosio Murrieta 106",
    city: "Aguascalientes, Ags.",
  },
  rating: { stars: 5, reviews: 31 },
};

export const waLink = (msg = "Hola Dr. González, me gustaría agendar una cita.") =>
  `https://wa.me/${CLINIC.whatsappNumber}?text=${encodeURIComponent(msg)}`;

export const telLink = `tel:${CLINIC.phoneNumber}`;

export const PHOTOS = {
  hero: "https://customer-assets.emergentagent.com/job_2da03fc0-9673-48bb-86a2-0274df7acb11/artifacts/nmlao192_fed6e6161e8b0123dbab5ef3d896bef6.jpeg",
  about: "https://customer-assets.emergentagent.com/job_2da03fc0-9673-48bb-86a2-0274df7acb11/artifacts/h2690u5d_Opera%20Instant%C3%A1nea_2026-05-04_163932_www.google.com.png",
  portrait: "https://customer-assets.emergentagent.com/job_2da03fc0-9673-48bb-86a2-0274df7acb11/artifacts/yfeqq0n8_1516559740851.jpg",
};
